module.exports = __webpack_public_path__ + "img/home_class_delete_disabled.f4624230.svg";